export enum ImageSize {
  Medium,
  Large,
  Original
}

export enum AspectRatio {
  Rectangle,
  Square
}

export class Image {
  original: string;
  optimizedMedium: string;
  optimizedLarge: string;
  originalURL: string;
  mediumURL: string;
  largeURL: string;

  static fromJSON(json: ImageJSON): Image {
    if (json) {
      const image = Object.create(Image.prototype);
      return Object.assign(image, json, {});
    }
    return null;
  }

  toJSON(): ImageJSON {
    return Object.assign({}, this, {});
  }

  constructor(public data: any) {
    let j: JSON = data;

    if (j['large']) {
      j = j['large'];
    } else if (j['mid']) {
      j = j['mid'];
    }

    this.original = j['original'];
    this.optimizedMedium = j['optimizedMedium'];
    this.optimizedLarge = j['optimizedLarge'];
  }
}

interface ImageJSON {
  original: string;
  optimizedMedium: string;
  optimizedLarge: string;
  mediumURL: string;
  largeURL: string;
}



// WEBPACK FOOTER //
// ./src/app/model/image.ts